'use strict';

import { BaseInlineFilter } from './base-inline-filter';
import template from './number-filter.html';

export class NumberFilter extends BaseInlineFilter {
	constructor(options) {
		super(options);

		this.type = 'number';
		this.panelTemplate = template;
		this.operators = this.filterOperatorsFactory.getOperatorsByType('Number');
		this.operatorOnForm = this.allOperators.Equals.value;
	}

	init(column) {
		this.inlineMask = column.AttributeValueType;
		super.init(column);
	}

	getNewValue() {
		switch (this.operatorOnForm) {
			case this.allOperators.IsSet.value:
			case this.allOperators.IsNotSet.value:
				return [];
			case this.allOperators.Between.value:
				return [parseFloat(this.valueOnForm), parseFloat(this.valueTo)];
			default:
				return [parseFloat(this.valueOnForm)];
		}
	}

	getNewInlineValue() {
		const value = parseFloat(this.inlineValue);
		return isNaN(value) ? [] : [value];
	}

	updateTitle() {
		switch (this.operator) {
			case this.allOperators.Between.value: {
				const dateFrom = this.value[0] ? `${this.i18n.get('components.common.dateFrom')}: ${this.value[0]}; ` : '';
				const dateTo = this.value[1] ? `${this.i18n.get('components.common.dateTo')}: ${this.value[1]}` : '';
				this.title = dateFrom + dateTo;
				break;
			}
			case this.allOperators.IsSet.value:
			case this.allOperators.IsNotSet.value:
				this.title = this.operatorTitle;
				break;
			default:
				this.title = isNaN(this.value[0]) ? '' : this.operatorLabel + ' ' + this.value[0];
		}
	}

	setDefault() {
		this.operatorOnForm = this.allOperators.Equals.value;
		this.valueOnForm = undefined;
		this.valueTo = undefined;
	}

	isFormValid() {
		var newValue = this.getNewValue();
		switch (this.operatorOnForm) {
			case this.allOperators.IsSet.value:
			case this.allOperators.IsNotSet.value:
				return true;
			case this.allOperators.Between.value:
				return !isNaN(newValue[0]) && !isNaN(newValue[1]);
			default:
				return !isNaN(newValue[0]);
		}
	}

	hasValue() {
		switch (this.operator) {
			case this.allOperators.IsSet.value:
			case this.allOperators.IsNotSet.value:
				return true;
			case this.allOperators.Between.value:
				return this.value && !isNaN(this.value[0]) && !isNaN(this.value[1]);
			default:
				return Boolean(this.value) && !isNaN(this.value[0]) && typeof this.value[0] === 'number';
		}
	}

	syncFormFromInline(inlineValue) {
		this.valueOnForm = inlineValue;
	}
}
